import { powerUpCommonStrings } from "@vendata/power-up-clients-common/strings";
import { test_utils_page } from "./pages/test-utils/TestUtilsPage.strings.ts";

// BEGIN WORKFLOW AREA string-imports FOR vue/add-view sdk/add-component
import { dashboard } from "./pages/dashboard/Dashboard.strings.ts";
import { dashboard_header } from "./pages/dashboard/DashboardHeader.strings.ts";
import { outstanding_transactions_display } from "./pages/dashboard/OutstandingTransactionsDisplay.strings.ts";
import { open_repairs_display } from "./pages/dashboard/OpenRepairsDisplay.strings.ts";
import { outstanding_only_filter_form } from "./pages/transactions/OutstandingOnlyFilterForm.strings.ts";
import { transactions } from "./pages/transactions/Transactions.strings.ts";
import { transactions_header } from "./pages/transactions/TransactionsHeader.strings.ts";
import { transactions_table_display } from "./pages/transactions/TransactionsTableDisplay.strings.ts";
import { transaction_detail } from "./pages/transaction-detail/TransactionDetail.strings.ts";
import { transaction_summary_display } from "./pages/transaction-detail/TransactionSummaryDisplay.strings.ts";
import { allocation_form } from "./pages/transaction-detail/AllocationForm.strings.ts";
import { allocations_display } from "./pages/transaction-detail/AllocationsDisplay.strings.ts";
import { repairs } from "./pages/repairs/Repairs.strings.ts";
import { repairs_header } from "./pages/repairs/RepairsHeader.strings.ts";
import { status_filter_form } from "./pages/repairs/StatusFilterForm.strings.ts";
import { repairs_table_display } from "./pages/repairs/RepairsTableDisplay.strings.ts";
import { repair_detail } from "./pages/repair-detail/RepairDetail.strings.ts";
import { repair_request_display } from "./pages/repair-detail/RepairRequestDisplay.strings.ts";
import { repair_edit_form } from "./pages/repair-detail/RepairEditForm.strings.ts";
import { status_updates_display } from "./pages/repair-detail/StatusUpdatesDisplay.strings.ts";
import { status_update_form } from "./pages/repair-detail/StatusUpdateForm.strings.ts";
import { status_update_compose_display } from "./pages/repair-detail/StatusUpdateComposeDisplay.strings.ts";
import { close_repair_form } from "./pages/repair-detail/CloseRepairForm.strings.ts";
import { close_repair_display } from "./pages/repair-detail/CloseRepairDisplay.strings.ts";
import { related_spend_display } from "./pages/repair-detail/RelatedSpendDisplay.strings.ts";
// END WORKFLOW AREA

export const admin_strings = {
  test_utils_page,
  // BEGIN WORKFLOW AREA string-object FOR vue/add-view sdk/add-component
  dashboard,
  dashboard_header,
  outstanding_transactions_display,
  open_repairs_display,
  outstanding_only_filter_form,
  transactions,
  transactions_header,
  transactions_table_display,
  transaction_detail,
  transaction_summary_display,
  allocation_form,
  allocations_display,
  repairs,
  repairs_header,
  status_filter_form,
  repairs_table_display,
  repair_detail,
  repair_request_display,
  repair_edit_form,
  status_updates_display,
  status_update_form,
  status_update_compose_display,
  close_repair_form,
  close_repair_display,
  related_spend_display,
  // END WORKFLOW AREA
  ...powerUpCommonStrings,
};
